import axios from 'axios';
import { LOGIN_URL, PERMISSIONS_URL } from 'api/session/constant';

// eslint-disable-next-line import/prefer-default-export
export function performLogin(credentials) {
  return axios
    .post(`${LOGIN_URL}`, credentials)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function getPermissions() {
  return axios.get(PERMISSIONS_URL);
}
